<template>
    <div>
        <template v-if="busy">
            <CenteredMessage :spinner="busy">
                <template>Lädt Widget...</template>
            </CenteredMessage>
        </template>
        <template v-else>
            <b-table :fields="fields" :items="items">
                <template v-slot:cell(status)="row">
                    <template v-if="row.value === 'on'">
                        <Dot class="bg-success" title="Online" />
                    </template>
                    <template v-else-if="row.value === 'off'">
                        <Dot class="bg-danger" title="Offline" />
                    </template>
                    <template v-else>
                        <Dot class="bg-secondary" />
                    </template>
                </template>
            </b-table>
        </template>
    </div>
</template>

<script>
import WidgetContent from "@/mixins/Widget/WidgetContent";
import CenteredMessage from "@/components/CenteredMessage/CenteredMessage";
import Dot from "@/components/Dot/Dot";

export default {
    name: "UserOverview",
    mixins: [WidgetContent],
    components: {
        CenteredMessage,
        Dot
    },
    props: ["url"],
    data() {
        return {
            fields: [
                {
                    key: "id",
                    label: "ID"
                },
                {
                    key: "name",
                    label: "Name"
                },
                {
                    key: "status",
                    label: "Status",
                    class: "text-center"
                }
            ],
            items: [],
            // timer: null,
            refreshing: false
        };
    },
    created() {
        this.fetch();
        this.timer = setInterval(this.refresh, 60000);
    },
    methods: {
        refresh() {
            this.refreshing = true;
            this.fetch(false);
            this.refreshing = false;
        },
        process(items) {
            const parsedItems = items.collection.map(item => {
                return {
                    id: item.mitglied_id,
                    name: item.vorname + " " + item.name,
                    status: this.parseStatus(item.lastInteraction)
                };
            });
            this.items = parsedItems;
        },
        parseStatus(status) {
            if (status) {
                var statusTS = this.$moment(status);
                var nowTS = this.$moment(Date.now());
                const diff = nowTS.diff(statusTS);
                const duration = this.$moment.duration(diff);
                const diffMin = duration.asMinutes();
                if (diffMin <= 10) {
                    return "on";
                } else {
                    return "off";
                }
            }
            return null;
        }
    },
    beforeDestroy() {
        clearInterval(this.timer);
    }
};
</script>
